// extracted by mini-css-extract-plugin
module.exports = {"text":"Show-module__text___rzTmJ","date":"Show-module__date___20nvp","docs":"Show-module__docs___JYiFe"};